// extracted by mini-css-extract-plugin
export default {"searchContainer":"LearningActivityListDropdown_searchContainer__CpUGn","selectButton":"LearningActivityListDropdown_selectButton__VbrdD"};